"use strict";
import {http} from '../../core';
const RequestService = http.create();
import Config from "../../app.config";
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    // 问题列表
    getList:function (params) {
        return RequestService.get("problem/list",params);
    },
    // 新增问题
    add:function (params) {
        return RequestService.post('problem/add',params);
    },
    // 修改问题
    update:function (params) {
        return RequestService.post('problem/update',params);
    },
    // 问题详情
    detail:function (params) {
        return RequestService.get("problem/detail",params);
    },
    // 删除问题
    deleteProblem:function (params) {
        return RequestService.post("problem/delete",params);
    },
    // 问题操作
    handle:function (params) {
        return RequestService.post("problem/handle",params);
    },
    // 繁忙度统计---组繁忙度
    busynessGroup:function (departmentId) {
        return RequestService.get("organization/group/busyness",{ departmentId:departmentId })
    },
    // 繁忙度统计---人员繁忙度
    busynessUser:function (userId) {
        return RequestbaseURL.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    },
    // 获取服务组
    getDepartmentList:function (params) {
        return RequestbaseURL.get('itsm/v2/organization/department/tree/children',params)
    },
    //新增时获取问题模板
    getProTemplateList(params){
        return RequestService.get('case/template/list',params)
    },
    //选择模板后请求模板详情
    getProTemplate(params){
        return RequestService.get('case/template/describe',{id:params})
    },
    // 根据关键字获取知识列表
    getKnowledgeList:function (params) {
        return RequestService.get("knowledge/query",params);
        // return Promise.resolve([
        //     { id:1 ,}
        // ])
    },
}
